enum DiscountType {
  AdminOverride = 'AdminOverride',
  Campaign = 'Campaign',
  CarpoolCredits = 'CarpoolCredits',
  CourtesyDiscount = 'CourtesyDiscount',
  CustomerReferral = 'CustomerReferral',
  CyberMondayDeal = 'CyberMondayDeal',
  DeliveryDiscount = 'DeliveryDiscount',
  EmployeeDiscount = 'EmployeeDiscount',
  GeicoTotalLoss = 'GeicoTotalLoss',
  TradeIncentive = 'TradeIncentive'
}

export default DiscountType;
